import React, { useContext, useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import { RunTest } from '../../RunTest/RunTest';
import Button from '../../UI/Button/Button';
import { SuccessModal } from '../../UI/SuccessModal/SuccessModal';
import { useAuth } from '../../../hooks/useAuth';
import ProfileButton from '../../ProfileButton/ProfileButton';
import { AvatarContext } from '../../../context/userData-context';
import SelectGroups from '../../SelectGroups/SelectGroups';
import NotificationBell from '../../Notifications/NotificationBell';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined';
import { IconButton, Tooltip } from '@mui/joy';
import { JiraIssueCollector } from './JiraIssueCollector';
import { apiUsers } from '../../../services/api.user';
import './NewNavLinks.css';

const customStyles = {
  content: {
    width: 1100,
    background: '#FFFFFF',
    border: 'none',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1), 0px 0px 30px rgba(0, 0, 0, 0.15)',
    borderRadius: '6px',
    padding: 0,
    margin: 'auto',
    inset: 'auto',
    position: 'relative' as React.CSSProperties['position']
  },
  overlay: {
    zIndex: 10,
    padding: 20,
    overflow: 'auto',
    display: 'flex'
  }
};

const NewNavLinks = () => {
  const { isSuperAdmin, group, isAuthenticated, logout } = useAuth();
  const sharedAvatar = useContext(AvatarContext);
  const dispatch = useDispatch();

  const [openProfile, setOpenProfile] = useState(false);
  const [openGroups, setOpenGroups] = useState(false);
  const [showSuccessInfo, setShowSuccessInfo] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [testType, setTestType] = useState('');
  const [count, setCount] = useState(6);

  const menuRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handler = (event: MouseEvent) => {
      if (menuRef.current && event.target instanceof Node && !menuRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
    };

    document.addEventListener('mousedown', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });

  const onCloseSelectGroups = () => {
    setOpenGroups(false);
  };

  const toggleProfile = () => {
    setOpenProfile(!openProfile);
  };

  Modal.setAppElement('body');

  function openModal() {
    setIsOpen(true);
    dispatch(apiUsers.util.invalidateTags(['UserTestRateLimit']));
  }

  function closeModal() {
    setIsOpen(false);
  }

  const closeSuccessModal = () => {
    setShowSuccessInfo(false);
    setCount(0);
    setIsOpen(false);
    if (testType === 'singleTestType' || testType === 'bulkTestType') {
      window.location.href = testType === 'singleTestType' ? '/search' : '/bulk';
    }
  };

  if (!isAuthenticated) {
    return (
      <div ref={menuRef}>
        <ul className="nav-links">
          <li>
            <div>
              <NavLink to="/login" className="basic-navlink">
                LOG IN
              </NavLink>
            </div>
          </li>
        </ul>
      </div>
    );
  }
  return (
    <div ref={menuRef}>
      <div className="nav-body">
        <div className="main-navigation__btns">
          <div className="main-navigation__btns-left">
            <JiraIssueCollector />
            <Tooltip title="Contact Helpdesk">
              <IconButton
                variant="plain"
                onClick={() => {
                  window.location.href = 'mailto:athena.helpdesk@cheil.com';
                }}
              >
                <HelpOutlineIcon sx={{ width: 28, height: 28, color: '#000000' }} />
              </IconButton>
            </Tooltip>
          </div>
          <div className="main-navigation__btns-right">
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={showSuccessInfo ? closeSuccessModal : closeModal}
              style={customStyles}
              contentLabel="Avatar Picker"
            >
              {showSuccessInfo ? (
                <SuccessModal count={count} closeSuccessModal={closeSuccessModal} />
              ) : (
                <RunTest onClose={closeModal} setShowSuccessInfo={setShowSuccessInfo} setTestType={setTestType} />
              )}
            </Modal>
            <button
              style={{
                height: 'auto',
                margin: 0,
                padding: 0
              }}
              onClick={() => setOpenGroups(!openGroups)}
            >
              <div className="main-navigation__group">
                <span>Active Group:</span>
                <span>{group?.name || ''}</span>
              </div>
            </button>
            <Button
              inverseBlue
              inverse
              type="button"
              style={{
                fontWeight: 'bold',
                padding: '0.7rem 1.5rem',
                marginLeft: '0.5rem'
              }}
              onClick={openModal}
            >
              Run test
            </Button>
            <NotificationBell />
            <Modal
              isOpen={openGroups}
              onRequestClose={() => onCloseSelectGroups()}
              style={customStyles}
              contentLabel="Groups Picker"
            >
              <SelectGroups onClose={() => onCloseSelectGroups()} />
            </Modal>
            <div id="user-buttons">
              <div className="user-buttons__profile">
                <span onClick={toggleProfile} className="user-buttons_btn-profile">
                  <img
                    src={sharedAvatar.avatar}
                    style={{ borderRadius: '50%' }}
                    alt="icon"
                    width="40px"
                    height="40px"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        {openProfile && (
          <div className="profile-popup">
            <ProfileButton to="/my-profile" text="My Profile" onClick={toggleProfile} />
            {isSuperAdmin && <ProfileButton to="/admin/dashboard" text="Admin Panel" />}
            <ProfileButton onClick={logout} text="Log Out" to="/" />
          </div>
        )}
      </div>
    </div>
  );
};

export default NewNavLinks;
